import * as React from "react";
import { FieldProgress, FieldProgressDelete } from "../../styles/form";

export const FieldLoader: any = (props: any) => (
  <FieldProgress size={25} thickness={4} isContact={props.isContact} />
);

export const FieldLoaderDelete: any = (props: any) => (
  <FieldProgressDelete size={25} thickness={4} isContact={props.isContact} />
);
